import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { SUFFIX, Unit } from '../../shared/common/units';
import { UnitsAdapter } from '../services/units-adapter/units.adapter';
import { LanguageStore, SUPPORTED_LANGUAGE } from '../../@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({
  name: 'systemTransformedUnits',
})
export class SystemTransformedUnitsPipe implements PipeTransform, OnDestroy {
  language: SUPPORTED_LANGUAGE;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private unitsAdapter: UnitsAdapter, private languageStore: LanguageStore) {
    this.languageStore.languageCode$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((_language) => {
      this.language = _language;
    });
  }

  transform(text: string): string {
    if (text) {
      let result = text;

      const cases = [
        {
          suffix: SUFFIX.celsius,
          unit: Unit.Celsius,
        },
        {
          suffix: SUFFIX.bar,
          unit: Unit.Bar,
        },
        {
          suffix: SUFFIX.litersPerHour,
          unit: Unit.LiterHour,
        },
        {
          suffix: SUFFIX.cubicMeter,
          unit: Unit.CubicMeter,
        },
        {
          suffix: SUFFIX.cubicMeterPerHour,
          unit: Unit.CubicMeterPerHour,
        },
      ];

      cases.forEach((entry) => {
        // match all expressions similar to "-20 °C" or "20 °C" or "°C"
        // optional -
        // optional value
        // mattch unit
        const regex = new RegExp(`(-?\\d+([.,]\\d+)?)?\\s*${entry.suffix}`, 'g');

        result = result.replace(regex, (_match, value) => {
          const systemUnit = this.unitsAdapter.getSuffix(entry.unit);

          if (!value) {
            return ` ${systemUnit}`;
          }

          let enGbDecimalValue = value;

          // This will work only for german translations with german values with proper german formatting
          if (this.language === SUPPORTED_LANGUAGE.DE) {
            enGbDecimalValue = value.replace('.', '|').replace(',', '.').replace('|', ',');
          }

          const transformedValue = parseFloat(enGbDecimalValue);
          const systemValue = this.unitsAdapter.getDisplayValue(transformedValue, entry.unit, {
            precision: 5,
          });

          return `${systemValue} ${systemUnit}`;
        });
      });

      return result;
    }

    return text;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
